import React from 'react';
import { PageHeader } from '@/ui/PageHeader';
import { NotesBoard, type NotesBoardMetaField } from '@/components/NotesBoard';

const STATUS_OPTIONS = ['not_contacted', 'in_talks', 'meeting_scheduled', 'partnered', 'declined'];

const META_FIELDS: NotesBoardMetaField[] = [
  { key: 'venue', label: 'Venue', placeholder: 'Venue name' },
  { key: 'contact', label: 'Contact', placeholder: 'Name / phone / email' },
];

export function VenueRelationsScreen() {
  return (
    <div className="admin-page max-w-3xl mx-auto">
      <PageHeader
        title="Venue Relations"
        subtitle="Bar & club partnership pipeline — venue, contact, and where each relationship stands."
      />
      <NotesBoard
        page="venue_relations"
        statusOptions={STATUS_OPTIONS}
        metadataFields={META_FIELDS}
        newButtonLabel="Add venue"
        emptyTitle="No venue relationships tracked yet"
        emptyHint="Add the first venue you're building a relationship with above."
      />
    </div>
  );
}
